<template>
  <v-card>
    <v-container fluid grid-list-md>
      <v-flex xs8 offset-xs2>
        <v-card-title primary-title class="justify-center">
          <div>
            <div class="display-1 font-weight-medium blue--text">Medical Certificate</div>
            <center>
              <span class="subheading grey--text">Read</span>
            </center>
          </div>
        </v-card-title>
      </v-flex>
    </v-container>
    
    <v-container fluid grid-list-md>
      <v-flex xs10 offset-xs1>
        <v-form>
          <v-text-field
          class="mx-3"
          background-color="blue lighten-5"
          outline
          label="Certificate ID"
          v-model.trim="searchCertificateID"
          append-icon="search"
          @click:append="callTo"
          ></v-text-field>
        </v-form>
        <p class="error">{{ error }}</p>
        <p>
          <center>
            <img src="~assets/images/scan_qrcode.png" class="cursor" @click="scanQrcode">
          </center>
        </p>

        <qrcode-stream :track="false" @decode="onDecode" @init="onInit" v-if="qrScan" :camera="camera" />
        
        <v-dialog v-model="execResultDialog" width="600px">
          <v-card img="images/myoffspring_border.png">
            <v-card-text>
              <v-container align-center grid-list-md text-md-center>
                <v-layout row wrap>
                  <v-flex xs6>
                    <img src="images/logo_althash_health_top.png" style="width: auto; height: 40px;">
                  </v-flex>
                  <v-flex xs6>
                    <img src="images/logo_althash.png" style="width: auto; height: 40px;">
                  </v-flex>
                  <v-flex xs12>
                    <span class="font-weight-medium my-2 headline font-italic">
                      Medical Certificate
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <p>
                      <b>01-Dec-2018</b>
                    </p>
                    <p>
                      Drivers License Applicant: <b>John Doe</b>
                    </p>
                    <p>
                      Physical and mentally fit to drive: <b>NO</b>
                      <br>
                      Reason(s): 
                      <br>
                      <ul>
                        <li>Post-poliomyelitis - With one paralyzed leg: Left</li>
                      </ul>
                    </p>
                    <p>
                      Has clear eyesight: <b>YES</b>
                    </p>
                    <p>
                      Has clear hearing: <b>YES</b>
                    </p>
                    <p>
                      Other findings: Applicant demonstrates need of psychological treatment.
                    </p>
                    <p>
                      <br>
                      Attending Physician: Dr. Paulo Barbosa
                      <br>
                      PRC: 1234567890 (valid until 12/2020)
                      <br>
                      PTR: 0987654321 (valid until 11/2019)
                    </p>
                    <p class="text-xs-center">
                      <img :src="qr" style="width: 75px; height: auto;"/>
                      <br>
                      <span class="caption">Certificate ID: {{ searchCertificateID }}</span>
                    </p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-container>
  </v-card>
</template>

<style scoped>
  .error {
    font-weight: bold;
    color: red;
  }

  .cursor:hover {
    cursor: pointer;
  }
</style>

<script>
  import webWallet from 'libs/web-wallet'
  import abi from 'ethjs-abi'
  import server from 'libs/server'

  import sha256 from 'js-sha256'

  import qrcode from 'qrcode'

  import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'

  export default {
    data () {
      return {
        date: new Date().toISOString().substr(0, 10),
        menu_date: false,
        gender: '',
        gender_items: ['Male','Female','Other'],
        address: '',
        phoneNumber: '',
        diagnosis: '',
        recommendation: '',
        daysOfRest: '1',
        error: null,
        qrScan: false,
        camera: false,
        contractAddress: '31346cbb09a178da67afda6b43e503faae1bbcfa',
        abi: '',
        parsedAbi: null,
        method: null,
        existingRecord: false,
        inputParams: [],
        fullName: '',
        motherFullName: '',
        fatherFullName: '',
        dateOfBirth: '',
        dateOfBirth_menu: false,
        timeOfBirth: null,
        timeOfBirth_menu: false,
        timePicker: false,
        placeOfBirth: '',
        gasPrice: '40',
        gasLimit: '2500000',
        fee: '0.01',
        confirmSendDialog: false,
        execResultDialog: false,
        rawTx: 'loading...',
        canSend: false,
        sending: false,
        hashID: '',
        searchCertificateID: '12345678900987654321',
        resultStatus: '',
        resultFullName: 'loading...',
        resultMotherFullName: 'loading...',
        resultFatherFullName: 'loading...',
        resultDateOfBirth: 'loading...',
        resultTimeOfBirth: 'loading...',
        resultPlaceOfBirth: 'loading...',
        qr: ''
      }
    },
    components:{
      QrcodeStream,
      QrcodeCapture
    },
    computed: {
      notValid: function() {
        //@todo valid the address
        const nameCheck = /^(?!\s*$).+/.test(this.fullName)
        const dateOfBirthCheck = /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(-)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/.test(this.dateOfBirth.split("-").reverse().join("-")) && parseInt(this.dateOfBirth.replace(/-/g,"")) <= parseInt(this.todayFormattedDate())
        const timeOfBirthCheck = this.timeOfBirth == '' || /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.timeOfBirth)
        const gasPriceCheck = /^\d+\.?\d*$/.test(this.gasPrice) && this.gasPrice > 0
        const gasLimitCheck = /^\d+\.?\d*$/.test(this.gasLimit) && this.gasLimit > 0
        const feeCheck = /^\d+\.?\d*$/.test(this.fee) && this.fee > 0.0001
        return !(nameCheck && dateOfBirthCheck && timeOfBirthCheck && gasPriceCheck && gasLimitCheck && feeCheck)
      }
    },
    watch: {
      method: function() {
        this.inputParams = []
      },
      dateOfBirth_menu (val) {
        val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    },
    methods: {
      scanQrcode(){
        if(!this.camera){
          this.searchCertificateID = ''
          this.qrScan = true
          this.camera = true
        }
        else{
          this.camera = false
        }

      },

      onDecode(certID) {
        this.searchCertificateID = certID
        this.camera = false
      },

      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permisson"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          }
        }
      },

      async send() {
        try {
          const abiJson = [{"constant": true, "inputs": [{"name": "hash", "type": "string"} ], "name": "getHeir", "outputs": [{"name": "result", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "hash", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "name": "newHeir", "outputs": [{"name": "result", "type": "string"} ], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"payable": true, "stateMutability": "payable", "type": "fallback"}, {"anonymous": false, "inputs": [{"indexed": false, "name": "hash", "type": "string"} ], "name": "heirEvent", "type": "event"} ]
          var newDateOfBirth = this.dateOfBirth.replace(/-/g,"")
          var newTimeOfBirth = this.timeOfBirth.replace(/:/g,"")
          this.hashID = sha256(this.fullName+this.motherFullName+this.fatherFullName+newDateOfBirth+newTimeOfBirth+this.placeOfBirth+Date.now())
          const encodedData = abi.encodeMethod(abiJson[1], [this.hashID, this.fullName, this.motherFullName, this.fatherFullName, newDateOfBirth, newTimeOfBirth, this.placeOfBirth]).substr(2)
          this.confirmSendDialog = true
          try {
            this.rawTx = await webWallet.getWallet().generateSendToContractTx(this.contractAddress, encodedData, this.gasLimit, this.gasPrice, this.fee)
          } catch (e) {
            this.$root.log.error('send_to_generate_tx_error', e.stack || e.toString() || e)
            alert(e.message || e)
            this.confirmSendDialog = false
            return false
          }
          this.canSend = true
        } catch (e) {
          this.$root.error('Params error')
          this.$root.log.error('send_to_contract_encode_abi_error', e.stack || e.toString() || e)
          this.confirmSendDialog = false
          return false
        }
      },

      async confirmSend() {
        this.sending = true
        try {
          const txId = await webWallet.getWallet().sendRawTx(this.rawTx)
          this.confirmSendDialog = false
          this.sending = false
          const txViewUrl = server.currentNode().getTxExplorerUrl(txId)
          this.$root.success(`Successful sent! You can follow the transaction on <a href="${txViewUrl}" target="_blank">${txViewUrl}</a>`, true, 0)
          this.$emit('send')

          this.fullName = ''
          this.motherFullName = ''
          this.fatherFullName = ''
          this.dateOfBirth = ''
          this.timeOfBirth = ''
          this.placeOfBirth = ''
        } catch (e) {
          alert(e.message || e)
          this.$root.log.error('send_to_contract_post_raw_tx_error', e.response || e.stack || e.toString() || e)
          this.confirmSendDialog = false
        }
      },

      async callTo() {
        if(this.searchHashID != ''){
          try {

            this.execResultDialog = true
            this.drawQrCode()
            /*
            const abiJson = [{"constant": true, "inputs": [{"name": "hash", "type": "string"} ], "name": "getHeir", "outputs": [{"name": "result", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "hash", "type": "string"}, {"name": "heirFullName", "type": "string"}, {"name": "motherFullName", "type": "string"}, {"name": "fatherFullName", "type": "string"}, {"name": "dateOfBirth", "type": "uint256"}, {"name": "timeOfBirth", "type": "uint256"}, {"name": "placeOfBirth", "type": "string"} ], "name": "newHeir", "outputs": [{"name": "result", "type": "string"} ], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"payable": true, "stateMutability": "payable", "type": "fallback"}, {"anonymous": false, "inputs": [{"indexed": false, "name": "hash", "type": "string"} ], "name": "heirEvent", "type": "event"} ]
            const encodedData = abi.encodeMethod(abiJson[0], [this.searchHashID]).substr(2)
            try {
              var encodedResult = await webWallet.getWallet().callContract(this.contractAddress, encodedData)
              encodedResult = '0x' + encodedResult
              var decodedResult = abi.decodeMethod(abiJson[0], encodedResult)
              var rawDoB = decodedResult[4].toString()
              var formattedDateOfBirth = ''
              if(rawDoB != '0'){
                formattedDateOfBirth = rawDoB.substring(0,4)+"-"+rawDoB.substring(4,6)+"-"+rawDoB.substring(6)
              }
              var rawToB = decodedResult[5].toString()
              var formattedTimeOfBirth = ''
              if(rawToB != '0'){
                switch(rawToB.length) {
                  case 3:
                    rawToB = '0' + rawToB
                    break;
                  case 2:
                    rawToB = '00' + rawToB
                    break;
                  case 1:
                    rawToB = '000' + rawToB
                    break;
                }
                formattedTimeOfBirth = rawToB.substring(0,2)+":"+rawToB.substring(2)
              }
              else{
                formattedTimeOfBirth = '00:00'
              }
              this.resultStatus = decodedResult[0]
              if(this.resultStatus == 'Heir record found.'){
                this.execResultDialog = true
                this.resultFullName = decodedResult[1]
                this.resultMotherFullName = decodedResult[2]
                this.resultFatherFullName = decodedResult[3]
                this.resultDateOfBirth = formattedDateOfBirth
                this.resultTimeOfBirth = formattedTimeOfBirth
                this.resultPlaceOfBirth = decodedResult[6]
                this.drawQrCode()
              }
              else{
                alert('Record not found!')
              }
            } catch (e) {
              this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e)
              alert(e.message || e)
              this.execResultDialog = false
            }
            */
          } catch (e) {
            this.$root.error('Params error')
            this.$root.log.error('call_contract_encode_abi_error', e.stack || e.toString() || e)
            return false
          }
        }
      },
      dateOfBirth_save (date) {
        this.$refs.dateOfBirth_menu.save(this.dateOfBirth)
      },
      timeOfBirth_save () {
        this.$refs.timeOfBirth_menu.save(this.timeOfBirth)
      },

      todayFormattedDate() {
        var today = new Date();

        var dd = today.getDate().toString();
        var mm = (today.getMonth()+1).toString(); //January is 0!
        var yyyy = today.getFullYear().toString();

        if(dd<10){
          dd='0'+dd;
        } 

        if(mm<10){
          mm='0'+mm;
        } 

        var formattedDate = yyyy+mm+dd;

        return formattedDate;
      },

      onCopySucc: function() {
        this.$root.success('copy success')
      },
      onCopyError: function() {
        this.$root.error('copy fail')
      },

      drawQrCode() {
        qrcode.toDataURL(`${this.searchCertificateID}`, (err, url) => {
          this.qr = url
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/controllers/Certdrivers-Read.vue